<template>
  <div>
    <div style="display: flex;flex-direction: row;height: 56px;">
      <div style="margin: 12px;display: flex;flex-direction: row;" v-if="srcPage===3">
        <el-button size="small" type="primary" icon="el-icon-circle-plus" style="margin-right: 12px;" :disabled="disabledBtn" @click="clickReturnFiles" v-if="srcPage===3">还原</el-button>
        <el-button size="small" type="primary" icon="el-icon-circle-plus" style="margin-right: 12px;" :disabled="disabledBtn" @click="clickConfirmDeleteFiles" v-if="srcPage===3">彻底删除</el-button>
      </div>
      <div style="margin: 12px;display: flex;flex-direction: row;" v-else>
        <el-button size="small" type="primary" icon="el-icon-circle-plus" style="margin-right: 12px;" @click="createNewDir" v-show="canUpload || canUploadCommon">新建文件夹</el-button>
        <el-button size="small" type="primary" icon="el-icon-edit" style="margin-right: 12px;" @click="clickRenameFile" v-show="canRenameFile && canUploadCommon">重命名</el-button>
        <el-upload v-show="canUpload || canUploadCommon"
          class="upload-demo"
          ref="upload"
          :http-request="changeFile"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :show-file-list="false"
          action="/"
          :disabled="isUploading"
          accept=".zip,.xls,.xlsx,.csv,image/*,audio/*,video/*,.rar,.tar.gz,.tar,.pdf,.doc,.dot,.docx,.json,.txt,.xltx,.potx,.ppsx,.pptx,.sldx,.dotx,.xlsm,.xlsb ">
          <el-button size="small" type="primary" icon="el-icon-upload" :disabled="isUploading" :loading="isUploading" style="margin-right: 12px;">{{uploadBtnText}}</el-button>
        </el-upload>
        <a :style="{'pointer-events': disabledDownload ? 'none': 'auto'}" type="text" @click="onClickDownload($event)" id="download_file_a" target="_blank">
          <el-button size="small" type="primary" icon="el-icon-download" :disabled="disabledDownload" style="margin-right: 12px;">下载</el-button>
        </a>
        <el-button size="small" type="primary" icon="el-icon-circle-plus-outline" :disabled="disabledBtn || disabledAddTagBtn" @click="clickAddFilesTag">添加标签</el-button>
        <el-button size="small" type="primary" icon="el-icon-circle-plus-outline" :disabled="disabledBtn || disabledRemoveTagBtn" @click="clickRemoveFilesTag">移除标签</el-button>
        <el-button size="small" type="primary" icon="el-icon-share" :disabled="disabledBtn" @click="clickShare">分享</el-button>
        <el-button size="small" type="primary" icon="el-icon-rank" :disabled="disabledBtn" @click="clickMoveToDir" v-show="canUpload || canUploadCommon">移动至</el-button>
        <el-button size="small" type="primary" icon="el-icon-remove-outline" style="margin-right: 12px;" :disabled="disabledBtn" @click="clickDeleteFiles" v-show="canUpload || canUploadCommon">删除</el-button>
      </div>
      <div style="display: flex;flex-direction: row;" align="right">
      <!--<div style="display: flex;flex-direction: row;" align="right" :style="{'margin-left': toolBarLeft+'px'}">-->
        <div style="margin-top: 12px;width: 300px;" class="search-box">
          <el-input size="small" placeholder="请输入内容" v-model="searchEnteredComputed" class="input-with-select" clearable>
            <el-button slot="append" icon="el-icon-search" @click="clickSearch"></el-button>
          </el-input>
        </div>
        <div style="margin: 15px 12px 0;" slot="reference">
          <el-dropdown trigger="click">
            <i v-if="isDescing" class="el-icon-cus-sortdescending" style="font-size: 30px;color: gray;"></i>
            <i v-else class="el-icon-cus-sort-ascending" style="font-size: 30px;color: gray;"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <span @click="clickSort(1)">文件名称</span></el-dropdown-item>
              <el-dropdown-item divided>
                <span @click="clickSort(2)">文件大小</span></el-dropdown-item>
              <el-dropdown-item divided>
                <span @click="clickSort(3)">修改时间</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div style="margin: 17px 0px 0px;">
          <i v-if="isArrange" class="el-icon-cus-arrange" style="font-size: 26px;color: gray;" @click="clickArrange"></i>
          <i v-else class="el-icon-cus-list" style="font-size: 26px;color: gray;" @click="clickArrange"></i>
        </div>

      </div>
    </div>
    <p class="line"></p>
    <el-dialog
      :title="tagDialogTitle"
      :visible.sync="centerDialogVisible_"
      width="24%"
      top="20%">
      <el-input v-if="operateType_ === 4"
                placeholder="请输入文件名称"
                v-model="inputFileName"
                clearable>
      </el-input>
      <el-select v-else v-model="selectedTag" placeholder="请选择">
        <el-option
          v-for="item in tagsListOptions"
          :key="item.tagId"
          :label="item.tagName"
          :value="item.tagId">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <!--<el-button v-if="operateType_ === 4" type="primary" size="mini" @click="clickConfirmAddTag">确 定</el-button>-->
        <el-button v-if="operateType_ === 4" type="primary" size="mini" @click="clickConfirmRenameFile">确 定</el-button>
        <el-button v-else type="primary" size="mini" @click="clickConfirmAddOrRemoveTag_" :disabled="selectedTag === null">确 定</el-button>
      </span>
    </el-dialog>
    <upload-progress></upload-progress>
    <uploading-file></uploading-file>
  </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex'
import ct from '../utils/constant.js'
import uploadingFile from './dialog/FileUploading.vue'
export default {
  mounted () {
  },
  props: ['checkRowList', 'fileRouterList', 'breadTitle', 'tagsListRemove', 'tagsListAdd', 'operateType'],
  data () {
    return {
      inputFileName: '',
      searchEntered: '',
      selectedTag: null,
      centerDialogVisible_: false,
      operateType_: null,
      baseUrl: 'static/img/',
      isUploading: false,
      isDescing: false,
      tagDialogTitle: '',
      isDownload: 0,
      rowDownloadCode: 0,
      downloadURL: '',
      maxSize: 1 * 1024 * 1024 * 1024 // maxSize 1g
    }
  },
  watch: {
    'currentTag': {
      handler: function (val) {
        let fn = this.getStorage('urlFileNameParam')
        this.searchEntered = fn || ''
      },
      deep: true
    },
    'isDownload': function (val) {
      let a = document.getElementById('download_file_a')
      a.href = 'fileRequest?fileGUID=' + this.checkRowList[0].fileGuid
      a.click()
      let _this = this
      setTimeout(function () {
        _this.$msgbox.close()
      }, 200)
    }
  },
  components: {
    uploadingFile
  },
  methods: {
    ...mapMutations(['setFilesList', 'setIsArrange', 'setSrcPage', 'setShowProgress', 'setUploadedFile', 'setUploadRequestData']),
    createNewDir () {
      let dirName = '新建文件夹'
      dirName = this.repeatNameHandler(dirName, false, this)
      let params = {dirName: dirName, parentGuid: this.currentDirGuid}
      this.postRequest('addDir', params).then(res => {
        let list = this.filesList
        list.unshift(res.data.result)
        this.setFilesList(list)
      })
    },
    clickRenameFile () {
      this.operateType_ = ct.OperateFileType.rename
      this.tagDialogTitle = '重命名文件'
      this.centerDialogVisible_ = true
      this.inputFileName = this.checkRowList[0].fileName
    },
    getFileDir (fileGuid, calback) {
      this.postRequest('listDirSubFiles', fileGuid).then(res => {
        let result = res.data.result
        calback && calback(result)
      })
    },
    clickSearch () {
      this.postRequest('searchFile', {orderColumn: ct.OrderColumn.updateDT, isDesc: true, input: this.searchEnteredComputed}).then(res => {
        if (res) {
          this.setFilesList(res.data.result)
        }
      })
    },
    /**
     * clickSort 1->文件名称 2->文件大小 3->修改时间
     */
    clickSort (type) {
      this.isDescing = !this.isDescing
      let col = ''
      if (type === 1) {
        col = ct.OrderColumn.fileName
      } else if (type === 2) {
        col = ct.OrderColumn.fileSize
      } else if (type === 3) {
        col = ct.OrderColumn.updateDT
      }
      /**
       * let files = this.filesList
       if (this.isDescing) {
        files = files.sort((x, y) => {
          let a = x[col]
          let b = y[col]
          if (col === 3) {
            return new Date(b) - new Date(a)
          } else if (col === 2) {
            return b - a
          } else {
            return b.localeCompare(a)
          }
        })
      } else {
        files = files.sort((x, y) => {
          let a = x[col]
          let b = y[col]
          if (col === 3) {
            return new Date(a) - new Date(b)
          } else if (col === 2) {
            return a - b
          } else {
            return a.localeCompare(b)
          }
        })
      }
       * @type {*}
       */
      // this.currentDirGuid
      if (this.fileRouterList.length === 0 && this.breadTitle.category !== ct.TagCategory.all) {
        this.postRequest('loadFilesByTag', {orderColumn: col, isDesc: this.isDescing, tagId: this.breadTitle.tagId}).then(res => {
          if (res && res.data) {
            this.setFilesList(res.data.result)
          }
        })
      } else {
        this.postRequest('loadFilesByFileGuid', {startIndex: 0, pageSize: 0, orderColumn: col, isDesc: this.isDescing, parentGuid: this.currentDirGuid}).then(res => {
          if (res && res.data) {
            this.setFilesList(res.data.result)
          }
        })
      }
    },
    clickArrange () {
      this.setIsArrange(!this.isArrange)
      this.$emit('clearCheckRow')
    },
    handlePreview () {},
    handleRemove () {},
    changeFile (options) {
      // todo upload request
      let file = options.file
      if (!file) {
        return
      }
      if (file.size > this.maxSize) {
        this.$message({
          message: `请选择小于${this.getFileSize(this.maxSize)}的文件`,
          type: 'error'
        })
        return
      }
      if (this.isUploading) {
        this.$message({message: '正在上传中', type: 'error'})
        return
      }
      this.isUploading = true
      let user = this.customerInfo.customerNo
      this.getFileMD5(file, md5 => {
        let fileName = this.repeatNameHandler(file.name, true, this)
        // console.log('fileName', fileName)
        let param = {}
        param.fileName = fileName
        param.fileSize = file.size
        param.fileMD5 = md5
        param.requestUser = user
        param.urType = ct.UploadOrReleaseType.cus
        param.parentGUID = this.currentDirGuid
        if (!this.canUploadCommon) {
          param.fileCategory = ct.FileType.cus
        } else {
          param.fileCategory = ct.FileType.common
        }
        this.uploadFileRequest('uploadRequest', param).then(res => {
          if (res && res.data.code === 0) {
            this.uploadFile(res.data.result, file)
          } else {
            this.isUploading = false
          }
        })
      })
    },
    uploadFile (data, file) {
      // console.log('uploadFile', data)
      this.setUploadRequestData(data)
      this.setShowProgress(true)
      let el = document.getElementById('web-uploader')
      el.style.zIndex = el.style.zIndex + 2
      document.getElementById('web-uploader').style.zIndex = '2005'
      this.setUploadedFile({name: file.name, size: this.getFileSize(file.size)})
      if (data) {
        this.uploadChunk(data, this, file, () => {
          // console.log('uploadSuccess')
        })
      }
    },
    clickMoveToDir () {
      this.$emit('openMoToDirDialog')
    },
    clickShare () {
      this.$emit('openShareDialog')
    },
    clickAddFilesTag () {
      this.tagDialogTitle = '添加标签'
      this.centerDialogVisible_ = true
      this.operateType_ = ct.OperateFileType.moveToTag
    },
    clickRemoveFilesTag () {
      this.tagDialogTitle = '移除标签'
      this.centerDialogVisible_ = true
      this.operateType_ = ct.OperateFileType.removeTag
    },
    clickConfirmAddTag () {
      let param = {tagId: this.selectedTag, fileGuids: this.fileGuids}
      this.postRequest('addFileTag', param).then(res => {
        if (res && res.data.code === 0) {
          this.operationTips(this)
          this.centerDialogVisible_ = false
          this.selectedTag = ''
          this.$emit('uploadFileList', res.data.result)
        }
      })
    },
    clickConfirmRenameFile () {
      let flag = false
      this.filesList.some(f => {
        if (f.fileName === this.inputFileName) {
          flag = true
        }
      })
      if (flag) {
        this.$message({message: '请勿提交重复的文件名称哦～', type: 'error'})
        return
      }
      this.postRequest('renameFile', {fileGuid: this.checkRowList[0].fileGuid, fileName: this.inputFileName}).then(res => {
        if (res && res.data.code === 0) {
          this.operationTips(this)
          this.fileChangeHandler(res)
          this.selectedTag = ''
        }
      })
      this.centerDialogVisible_ = false
    },
    fileChangeHandler (res) {
      let list = this.filesList
      let index = null
      for (let i = 0; i < list.length; i++) {
        if (list[i].fileGuid === this.checkRowList[0].fileGuid) {
          index = i
          break
        }
      }
      list.splice(index, 1, res.data.result)
      this.setFilesList(list)
    },
    clickConfirmAddOrRemoveTag_ () {
      this.centerDialogVisible_ = false
      console.log('clickConfirmAddOrRemoveTag_')
      this.$emit('clickConfirmAddOrRemoveTag', true, this.operateType_, this.selectedTag)
    },
    clickDeleteFiles () {
      this.postRequest('deleteFile', this.fileGuids).then(res => {
        if (res && res.data.code === 0) {
          this.operationTips(this)
          this.fileDeleteHandler()
        }
      })
    },
    clickConfirmDeleteFiles () {
      this.postRequest('deleteFileCompletely', this.fileGuids).then(res => {
        if (res && res.data.code === 0) {
          this.operationTips(this)
          this.fileDeleteHandler()
          this.$emit('deleteCheckRow')
        }
      })
    },
    clickReturnFiles () {
      this.postRequest('revertFileFromRecycleBin', this.fileGuids).then(res => {
        if (res && res.data.code === 0) {
          this.fileDeleteHandler()
        }
      })
    },
    fileDeleteHandler () {
      let list = this.filesList
      this.checkRowList.forEach(f => {
        list = list.filter(l => l.fileGuid !== f.fileGuid)
      })
      this.setFilesList(list)
    },
    onClickDownload (e) {
      if (this.checkRowList.length === 1) {
        // eslint-disable-next-line
        this.$confirm(ct.DownloadFileTip, '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // confirm
          this.isDownload = Math.random() * 1000
        }).catch(() => {
          // cancel
        })
      }
      if (this.isDownload === this.rowDownloadCode) {
        e.preventDefault()
      }
      this.isDownload = this.rowDownloadCode
    }
  },
  computed: {
    ...mapState(['toolBarLeft', 'filesList', 'currentDirGuid', 'isArrange', 'srcPage', 'currentTag', 'tagsList', 'showProgress', 'customerInfo', 'isCommonFileAdmin', 'isCloudAdmin']),
    disabledBtn () {
      return (this.checkRowList === null || this.checkRowList.length === 0)
    },
    tagsListOptions_ () {
      let tags = this.tagsList.filter(t => t.tagType === 2)
      // console.log('tagsListOptions-toolbar')
      this.checkRowList.forEach(f => {
        let tagsExist = f.tags
        if (!tagsExist) {
          return []
        }
        if (tagsExist.length > 0) {
          for (let i = 0; i < tagsExist.length; i++) {
            let t = tagsExist[i]
            for (let j = 0; j < tags.length; j++) {
              let tag = tags[j]
              if (t.tagId === tag.tagId) {
                tags.splice(j, 1)
              }
            }
          }
        }
      })
      return tags
    },
    disabledAddTagBtn () {
      return this.tagsListAdd.length === 0
    },
    disabledRemoveTagBtn () {
      console.log('disabledRemoveTagBtn')
      return this.tagsListRemove.length === 0 || this.checkRowList.length > 1
    },
    fileGuids () {
      let fileGuids = []
      this.checkRowList.forEach(f => {
        fileGuids.push(f.fileGuid)
      })
      return fileGuids
    },
    uploadBtnText () {
      if (this.isUploading) {
        return '上传中'
      }
      return '上传文件'
    },
    canUpload () {
      return this.fileRouterList.length > 0 && this.fileRouterList[0].category === ct.FileType.cus
    },
    canUploadCommon () {
      console.log('canUploadCommon')
      return this.fileRouterList.length > 1 && this.fileRouterList[1].category === ct.FileType.common && (this.isCloudAdmin === ct.Boolean.yes || this.isCommonFileAdmin === ct.Boolean.yes)
    },
    canShare () {
      return this.fileRouterList.length > 0
    },
    canRenameFile () {
      return this.checkRowList.length === 1
    },
    searchEnteredComputed: {
      get () {
        let val = this.searchEntered
        if (val === '') {
          let tag = this.currentTag
          if (tag.category === 2) {
            return 'label:' + tag.tagName
          } else {
            return ''
          }
        }
        return this.searchEntered
      },
      set (val) {
        this.searchEntered = val
      }
    },
    disabledDownload () {
      let row = this.checkRowList
      if (row.length === 1) {
        return row[0].isDir === ct.Boolean.yes
      }
      return true
    },
    tagsListOptions () {
      if (this.tagsListAdd.length > 0) {
        return this.tagsListAdd
      } else {
        return this.tagsListRemove
      }
    }
  }
}
</script>
<style>
  .download-button-a {
    text-decoration: none;
    color: #fff;
    background-color: #409eff;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    border: 1px solid #409eff;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    transition: .1s;
    font-weight: 500;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    padding: 9px 15px;
    font-size: 12px;
    border-radius: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ToolBar.vue